import React from 'react';
import tpl from './templates/interactive';
import BaseNewCardView from '../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    shouldFetchData() {
        return false;
    }

    static displayName = 'PersonalData';
}
